import moment from 'moment-timezone';

import {
  dateFormat,
  longDateFormat,
} from '@qality/common-config/src/constants';

export const formatDate = (
  date: string | number,
  format?: 'dateFormat' | 'longDateFormat'
): string | null => {
  // defaultFormat
  let choosenFormat;

  switch (format) {
    case 'dateFormat':
      choosenFormat = dateFormat;
      break;
    case 'longDateFormat':
      choosenFormat = longDateFormat;
      break;
    default:
      choosenFormat = dateFormat;
  }

  if (date) {
    return moment(date).format(choosenFormat);
  }

  return null;
};
